import { NexusFrame } from "@nexus/nexus-shell";
import { Outlet, useLocation, useNavigate } from "react-router";
import { PORTAL_PATHS } from "../paths.js";
import type { RuntimeConfig } from "../runtime-config.js";

/**
 * The portal inside the Nexus frame (NEX2-232). The frame is `@nexus/nexus-shell`'s, shared with
 * Checkout; this says which app is drawing it, which rail item the current path is, and lends it
 * the router. Checkout opens at the origin the runtime document's `links` names.
 */
export function PortalFrame({ config }: { config: RuntimeConfig }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <NexusFrame
      active={pathname === PORTAL_PATHS.home ? "home" : null}
      apiOrigin={config.apiOrigin}
      app="portal"
      environment={config.environment}
      links={config.links}
      onNavigate={(path) => {
        void navigate(path);
      }}
    >
      <Outlet />
    </NexusFrame>
  );
}
